import { CommandWeightMap } from './weightedSelection';
import { CommandType } from '../types';

// HP フェーズ境界値
const PHASE_LATE = 0.3;
const PHASE_EARLY = 0.7;

/**
 * HPフェーズに応じたボス専用コマンドウェイトモディファイアを返す
 *
 * 各値は lookahead のペアスコアへの乗数（1.0 = 変化なし）。
 * エレボスのフェーズ別行動パターン:
 *   - 序盤: スタンス切替・様子見重視
 *   - 中盤: 物理攻撃＋リフレクター重視
 *   - 終盤: 特殊攻撃＋遠距離重視
 */
export function getBossCommandMods(hpRatio: number): CommandWeightMap {
  if (hpRatio >= PHASE_EARLY) {
    return {
      [CommandType.STANCE_A]: 1.8,
      [CommandType.STANCE_B]: 1.8,
      [CommandType.REFLECTOR]: 1.4,
    };
  }
  if (hpRatio > PHASE_LATE) {
    return {
      [CommandType.WEAPON_ATTACK]: 1.6,
      [CommandType.REFLECTOR]: 2.0,
    };
  }
  return {
    [CommandType.SPECIAL_ATTACK]: 2.5,
    [CommandType.RETREAT]: 1.5,
  };
}
